import React, { useRef, useLayoutEffect, useState } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

// 样式
import style from './Progress.module.scss'

const Progress = (props) => {
  const {percentage = '', text, trackColor, barColor, cursor, cursorColor, cursorStyle, isShowCursor = true} = props
  // 将数字转换为百分比
  const numAddPercent = percentage.toString().indexOf('%') > 0 ? percentage : `${percentage || 0}%`
  const cursorRef = useRef(null)
  const boxRef = useRef(null)
  // const extraRef = useRef(null)
  const [isOver, setOver] = useState(false)

  // 获取浮标位置
  function getCursorOffset(childRef, parentRef) {
    if ( childRef.current.offsetWidth + childRef.current.offsetLeft >  parentRef.current.offsetWidth) {
      setOver(true)
    }
  }
  // 动态修正浮标位置
  useLayoutEffect(()=>{

    getCursorOffset(cursorRef, boxRef)


  }, [percentage])

  return <div ref={boxRef}
      style={{ background: trackColor,overflow:`${isShowCursor?'visible':'hidden'}` }}
      styleName="box">
          {
              <>
                <div style={{
                      width: numAddPercent,
                      background: barColor,
                    }}
                    styleName="bar"
                  >
                </div>
                {
                  React.isValidElement(cursor) ?
                  <>{cursor}</>:
                  <div ref={cursorRef}
                      style={{
                          left: numAddPercent,
                          borderColor: trackColor,
                          background: cursorColor,
                          ...cursorStyle,
                        }}
                      styleName={
                          classNames({
                            cursor: true,
                            fixPos: isOver,
                            cursorsize:!cursor,
                          })
                        }>
                        {cursor}
                    </div>
                }
              </>
          }
          { text > 0 &&  <div styleName="text">{text}</div>}
      </div>
}

export default CSSModules(Progress, style, {allowMultiple: true})